import { requiredPercentNumber, optionalPercentNumber } from '../../util/customPropTypes';
export var propTypes = {
    percent: requiredPercentNumber,
    innerRadiusPercent: optionalPercentNumber
};
//# sourceMappingURL=types.js.map